// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate
/* eslint-disable no-template-curly-in-string */

export const spousal = {
  spousal_plan_comparison: {
    contentful_name: 'Spousal Plan Comparison (DEFAULT DO NOT CHANGE)',
    button_text: {
      remove: '- 移除福利',
      openPDF: '我需要什么来制定计划?',
      complete: '比较此计划',
      drugTier: '添加层级',
      editModal: '编辑您的计划',
      openModal: '家庭计划比较',
      benefitToggle: {
        copay: '定额共付',
        coinsurance: '共同保险',
      },
      premiumPeriod: {
        prefix: '每',
        options: ['每周', '每两周', '每半月', '每月', '每年'],
        periodNames: {
          weekly: '每周',
          monthly: '每月',
          annually: '每年',
          biweekly: '每两周',
          semimonthly: '每半月',
        },
      },
    },
    page_title: '家庭套餐对比',
    heading: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'heading-2',
          content: [
            {
              nodeType: 'text',
              value: '让我们比较配偶或伴侣计划',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '您可能有雇主提供之外的健康保险选择。您可以使用此工具输入您伴侣的计划信息,并将其与雇主的选项进行比较。请输入网络内保障的数值。如果您不知道某个数值,请尽可能进行估算。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    necessary_information: {
      items: [
        {
          link: 'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_English-2023-12-05.pdf#page=3',
          name: '保费',
          type: 'premium',
        },
        {
          link: 'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_English-2023-12-05.pdf#page=6',
          name: '自付费用上限',
          type: 'oopMax',
        },
        {
          link: 'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_English-2023-12-05.pdf#page=2',
          name: '福利摘要',
          type: 'benefits',
        },
        {
          link: 'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_English-2023-12-05.pdf#page=4',
          name: '免赔额',
          type: 'deductible',
        },
      ],
      question: '我需要哪些计划信息?',
    },
    details_title: '计划详情',
    threshold_warning: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '在下方字段中输入网络内',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '家庭门槛',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '值。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    premium_question: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '该计划的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '保费',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '是多少,按月计算?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    deductible_question: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '该计划的年度',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '免赔额',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '是多少?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    deductible_subfields: {
      expand: '等等,我的计划有单独的医疗和药品免赔额。',
      contract: '没关系,我的计划有联合免赔额。',
      drugText: '药品免赔额',
      healthText: '医疗免赔额',
    },
    oop_max_question: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '该计划的年度',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '自付费用上限',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '是多少?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    oop_max_fields: {
      expand: '等等,我的计划有独立的医疗和药品自付最高限额。',
      contract: '没关系,我的计划有联合自付最高限额。',
      drugText: '药品自付最高限额',
      healthText: '医疗自付最高限额',
    },
    validation_messages: {
      oopMaxValidationError: '符合HSA资格的计划的自付费用上限不能超过${x}',
      benefitCategoryRequired: '在符合HSA资格的计划中,此类别必须受免赔额限制',
      deductibleExceedsOopMax: '免赔额不能超过自付费用上限',
      deductibleValidationError: '符合HSA资格的计划的免赔额必须至少为${x}',
      splitOopMaxValidationError: '符合HSA资格的计划不设单独的医疗和药品自付费用上限',
      deductibleExceedsSplitOopMax: '免赔额不能超过医疗和药品自付费用上限的总和',
      splitDeductibleExceedsOopMax: '医疗和药品免赔额的总和不能超过自付费用上限',
      splitDeductibleValidationError: '符合HSA资格的计划不设单独的医疗和药品免赔额',
      drugDeductibleExceedsDrugOopMax: '药品免赔额不能超过药品自付费用上限。',
      healthDeductibleExceedsHealthOopMax: '医疗免赔额不能超过医疗自付费用上限。',
    },
    hsa_eligible_question: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '该计划是否会有来自您或您雇主的',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'HSA供款',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    hsa_contribution_question: {
      yearly: '每年',
      question: '雇主每年向HSA账户缴纳多少?',
    },
    hsa_question: {
      yearly: '每年',
      eligibility: '此计划是否符合HSA资格?',
      contribution: '雇主的年度HSA供款是多少',
    },
    hra_eligible_question: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '此计划是否',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '符合 HRA 资格',
              marks: [
                {
                  type: 'underline',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    hra_contribution_question: {
      yearly: '每年',
      question: '雇主的年度HRA供款是多少?',
    },
    hra_question: {
      yearly: '每年',
      eligibility: '此计划是否符合HRA资格?',
      contribution: '雇主的年度HRA供款是多少',
    },
    benefits_title: '计划福利',
    deductible_benefit: {
      text: '某些福利可能在您达到免赔额之前提供。对于这些福利,请取消选中下面的复选框。',
      title: '受免赔额限制',
    },
    benefit_groups: {
      drug: {
        title: '您需要为处方药支付多少费用?请选择您计划的所有药品福利。',
        types: {
          specialty: '特殊药品(第4级)',
          generic_tier_1: '仿制药(第1级)',
          preferred_tier_2: '优选品牌药(第2级)',
          non_preferred_tier_3: '非优选品牌药(第3级)',
        },
      },
      office: {
        title: '如果您去诊所就诊,您需要支付多少费用?',
        types: {
          specialist: '专科医生就诊',
          primaryCare: '初级保健就诊',
          preventiveCare: '预防保健',
        },
      },
      testing: {
        title: '如果您需要做检查,您需要支付多少费用?',
        types: {
          imaging: '影像检查',
          laboratory: '化验检查',
        },
      },
      hospital: {
        title: '如果您需要住院,您需要支付多少费用?',
        types: {
          hospitalFacilityFee: '医疗机构费用',
        },
      },
      emergency: {
        title: '如果您需要紧急医疗救治,您需要支付多少费用?',
        types: {
          urgentCare: '急诊护理',
          emergencyCare: '急救护理',
        },
      },
      outpatientSurgery: {
        title: '如果您需要进行门诊手术,您需要支付多少费用?',
        types: {
          services: '医生和手术服务',
          outpatientFacilityFee: '医疗机构费用',
        },
      },
    },
    card: {
      tag: '已输入计划',
      icon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/plancomparison/compare-scale.svg',
      text: '您可能有其他医疗保险选择。您可以使用此工具输入数据并比较其他计划,例如配偶或伴侣的计划。',
      title: '想了解其他选择的对比情况吗?',
      editIcon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/plancomparison/edit.svg',
      editText: '您一次只能比较一个非雇主计划。点击此处编辑您的计划。',
      editTitle: '编辑您输入的计划',
    },
    instructions_url:
      'https://picwellapppublicdata.s3.amazonaws.com/Build-a-plan+instructions_Chinese-2023-12-05.pdf',
    accessibility: {
      oopMaxAmount: '自付费用最高限额',
      premiumAmount: '保费金额',
      deductibleAmount: '免赔额',
      drugOopMaxAmount: '药品自付费用最高限额',
      healthOopMaxAmount: '医疗自付费用最高限额',
      drugDeductibleAmount: '药品免赔额',
      healthDeductibleAmount: '医疗免赔额',
      employerHraContribution: '雇主健康报销账户供款',
      employerHsaContribution: '雇主健康储蓄账户供款',
      benefitCostSharingAmount: '福利费用分摊金额',
    },
  },
};
